import { Currency } from '@/core/currency/interfaces';

const MKD: Currency = {
    name: 'Macedonian Denar',
    demonym: 'Macedonian',
    majorSingle: 'Denar',
    majorPlural: 'Denars',
    codeNumeric: '807',
    symbol: 'den',
    symbolNative: 'ден',
    minorSingle: 'Deni',
    minorPlural: 'Deni',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MKD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MKD;
